<template>
  <div>
    <div style="display:none">{{triggerDialog}}</div>
    <el-dialog
      class="popup NC-setting"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      top="0"
    >
      <div class="popupContainer">
        <div class="p-head">
          名片設定
        </div>
        <SaleBusinessCardPreview></SaleBusinessCardPreview>
        <SaleBusinessCardChoiseColorEnum></SaleBusinessCardChoiseColorEnum>
        <b-container fluid class="padding-bottom-10px">
          <b-row>
            <b-col cols="3">
            </b-col>
            <b-col>
              <b-container fluid>
                <b-row>
                  <b-col >
                    <b-form-textarea
                      id="textarea-state"
                      v-model="saleBusinessCard.selfIntro"
                      placeholder="請輸入自我介紹(上限150字)"
                      rows="4"
                      no-resize
                    ></b-form-textarea>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
            <b-col cols="3">
            </b-col>
          </b-row>
        </b-container>
        <div class="p-foot">
          <a @click="save" style="color: #fff;">設定</a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { SaleBusinessCardHandler } from "../../handler/SaleBusinessCardHandler.js";
import store_dialog from "../../vuex/store_dialog.js";
import store_saleBusinessCard from "@/vuex/store_saleBusinessCard.js";
import SaleBusinessCardPreview from "../../components/Main/SaleBusinessCardPreview.vue";
import SaleBusinessCardChoiseColorEnum from "../../components/Main/SaleBusinessCardChoiseColorEnum.vue";

export default {
  name: "MainToolBarStaff",
  components: {
    SaleBusinessCardPreview,
    SaleBusinessCardChoiseColorEnum
  },
  data() {
    return {
      dialogVisible: false,
      businesscard: {
        Version: "",
        SelfIntroduction: ""
      }
    };
  },
  methods: {
    save: function() {
      this.businesscard.SelfIntroduction = store_saleBusinessCard.state.selfIntro;
      this.businesscard.Version = store_saleBusinessCard.state.colorEnum;
      var err = "";
      if (this.businesscard.SelfIntroduction.length == 0) {
        err = "自我介紹不得為空 ";
      }
      if (this.businesscard.SelfIntroduction.length > 150) {
        err = "自我介紹不得超過150字元 ";
      }

      if (err.length > 0) {
        alert(err);
        return false;
      }
      
      var staff = this.GetLoginStaff();
      SaleBusinessCardHandler.SaveBusinessCard(this.businesscard, staff.staffid);
      this.handleClose();
    },
    handleOpen: function() {
      this.dialogVisible = true;
    },
    handleClose: function() {
      this.dialogVisible = false;
      store_dialog.dispatch("showDialogEditSaleBusinessCard", "0");
    }
  },
  computed: {
    triggerDialog() {
      if (store_dialog.state.editSaleBusinessCardFlag != "0") {
        this.handleOpen();
      }
      else{
        this.handleClose();
      }
    },
    saleBusinessCard() {
      return store_saleBusinessCard.state;
    }
  },
  watch:{
    'businesscard.SelfIntroduction': function(newD, oldD) {
      store_saleBusinessCard.dispatch(
        "setSelfIntro",
        newD
      );
    }
  }
};
</script> 



<style>
.padding-bottom-10px {
    padding-bottom: 10px!important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/Dialog_EditSaleBusinessCard.vue